import { gql } from '@apollo/client';

export const SUGGEST_CHANGE_FIELDS = gql`
  fragment SuggestChangeFields on SuggestChange {
    id
    payload
    partyStatus
    status
    creatorType
    receiverType
    policy {
      review
      update
    }
  }
`;
